<!-- 
程式：FireReserveModal.vue
功能：火險預約單明細
作者：i9400520
完成：2019-01-07
-->
<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div v-if="open" class="modal-content" :class="{'section-loading': isDataLoading}">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="modal-body">
          <table class="table insurance-green">
            <tr>
              <th class="text-green text-right" width="120">通訊地址</th>
              <td>{{infoAddr}}</td>
            </tr>
            <tr>
              <th class="text-green text-right" width="120">電子郵件</th>
              <td></td>
            </tr>
          </table>
          <br>
          <table class="table insurance-green">
            <tr>
              <th class="text-green">
                標的物
                <br>地址
              </th>
              <th class="text-green">
                總樓
                <br>層數
              </th>
              <th class="text-green">坪數</th>
              <th class="text-green">貸款戶</th>
              <th class="text-green">非貸款戶</th>
              <th class="text-green">保險起保日</th>
              <th class="text-green">
                欲投保
                <br>險種
              </th>
            </tr>
            <tr v-for="(item, index) in infoDetail" :key="index">
              <td>{{item.object_address || ''}}</td>
              <td>{{item.main_building_floor || ''}}</td>
              <td>{{item.main_building_area || ''}}</td>
              <td>{{item.loan_kind || ''}}</td>
              <td>{{item.is_continue_policy || ''}}</td>
              <td>{{item.start_datetime || ''}}</td>
              <td>{{item.policy_kind || ''}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarReserveModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isDataLoading: false,
      infoDetail: {},
      infoAddr: ""
    };
  },
  watch: {
    detailData: "syncDataFromSuperComponent",
    loading: "syncDataFromSuperComponent"
  },
  methods: {
    syncDataFromSuperComponent() {
      this.isDataLoading = this.loading;
      this.infoDetail = this.detailData;
      if (this.infoDetail && this.infoDetail.length > 0) {
        this.infoAddr = this.infoDetail[0].customer_address;
      } else {
        this.infoAddr = "";
      }

      this.infoDetail.forEach(info => {
        if (info.policy_kind === `住宅火險險及地震基本保險`) {
          info.policy_kind = `住宅火險`;
        } else if (info.policy_kind === `住宅火險險及地震基本保險`) {
          info.policy_kind = `住家綜合險`;
        }

        if (info.loan_kind === `null`) {
          info.loan_kind = ``;
        }

        if (info.is_continue_policy === `null`) {
          info.is_continue_policy = ``;
        }
      });

      this.registerHanlink(); // for hard word
    }
  }
};
</script>